import { defineStore } from 'pinia';
import { reactive, computed } from 'vue';

export const useClickStore = defineStore('click', () => {
  const state = reactive({
    toggleEvents: {
      isSidebarOpen: true,
    },
    openSearchbar: false,
    overlay: false,
  });

  const isSidebarOpen = computed(() => state.toggleEvents.isSidebarOpen);
  const isOverlayActive = computed(() => state.overlay);
  const isSearchbarOpen = computed(() => state.openSearchbar);

  function toggleSidebar() {
    state.toggleEvents.isSidebarOpen = !state.toggleEvents.isSidebarOpen;
    state.overlay = !state.overlay;
  }

  function toggleSearchBar() {
    state.openSearchbar = !state.openSearchbar;
  }

  function closeOverlay() {
    Object.keys(state.toggleEvents).forEach(item => {
      state.toggleEvents[item] = false;
    });
    state.overlay = false;
  }

  function showSidebar() {
    state.toggleEvents.isSidebarOpen = true;
    state.overlay = false;
  }

  function toggleBigScreenSidebar() {
    state.toggleEvents.isSidebarOpen = !state.toggleEvents.isSidebarOpen;
  }

  return {
    state,
    isSidebarOpen,
    isOverlayActive,
    isSearchbarOpen,
    toggleSidebar,
    toggleSearchBar,
    closeOverlay,
    showSidebar,
    toggleBigScreenSidebar,
  };
});
